import { Activity, Building2, Gauge, Hash, Package, Receipt, Server, Settings, ShieldCheck, Users } from 'lucide-react';
import type { NavGroup } from '@ui/components/layout/Shell';

export const ADMIN_NAV: NavGroup[] = [
  { group: '', items: [{ to: '/', label: 'Overview', icon: Gauge, keywords: 'revenue profit' }] },
  {
    group: 'Customers',
    items: [
      { to: '/organizations', label: 'Organizations', icon: Building2, keywords: 'clients wallet credit' },
      { to: '/billing', label: 'Billing', icon: Receipt, keywords: 'payments minutes receipts invoices paid tax hst' },
      { to: '/users', label: 'Users', icon: Users }
    ]
  },
  {
    group: 'Inventory',
    items: [
      { to: '/numbers', label: 'Phone numbers', icon: Hash, keywords: 'telnyx assign' },
      { to: '/catalog', label: 'Catalog & pricing', icon: Package, keywords: 'voices llm rates markup' }
    ]
  },
  {
    group: 'Operations',
    items: [
      { to: '/calls', label: 'Calls & costs', icon: Activity, keywords: 'telnyx reconcile margin' },
      { to: '/audit', label: 'Audit log', icon: ShieldCheck },
      { to: '/system', label: 'System health', icon: Server, keywords: 'queues redis' },
      { to: '/settings', label: 'Platform settings', icon: Settings, keywords: 'branding signup' }
    ]
  }
];
